import { render, staticRenderFns } from "./TempVoiceSettings.vue?vue&type=template&id=9eb0b9b6"
import script from "./TempVoiceSettings.vue?vue&type=script&lang=js"
export * from "./TempVoiceSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports